// Test authentication utility
import { supabase } from './supabase';

import logger from '@/utils/logger';
export async function testAuthentication() {
  logger.info('Testing Supabase Authentication...');
  logger.info('==================================');
  
  try {
    // Test 1: Check Supabase connection
    const { error: healthError } = await supabase
      .from('organizations')
      .select('count')
      .limit(1);
    
    if (healthError) {
      logger.error('❌ Supabase connection failed:', healthError.message);
    } else {
      logger.info('✅ Supabase connection successful');
    }
    
    // Test 2: Check current session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError) {
      logger.error('❌ Session check failed:', sessionError.message);
    } else if (session) {
      logger.info('✅ Active session found');
      logger.info('   User email:', session.user.email);
      logger.info('   User ID:', session.user.id);
      logger.info('   Provider:', session.user.app_metadata.provider);
    } else {
      logger.info('ℹ️  No active session');
    }
    
    // Test 3: Check user profile
    if (session?.user) {
      const { data: profile, error: profileError } = await supabase
        .from('users')
        .select('*')
        .eq('id', session.user.id)
        .single();
      
      if (profileError) {
        logger.error('❌ Profile fetch failed:', profileError.message);
      } else {
        logger.info('✅ User profile found');
        logger.info('   Organization ID:', profile.organization_id);
        logger.info('   Full name:', profile.full_name);
      }
    }
    
    // Test 4: Check Google OAuth configuration
    logger.info('\nGoogle OAuth Configuration:');
    logger.info('   Redirect URL:', `${window.location.origin}/internal`);
    logger.info('   Domain restriction: @lendwisemtg.com');
    
    return {
      connected: !healthError,
      authenticated: !!session,
      user: session?.user || null
    };
    
  } catch (error) {
    logger.error('❌ Test failed with error:', error);
    return {
      connected: false,
      authenticated: false,
      user: null
    };
  }
}

// Export for use in browser console
if (typeof window !== 'undefined') {
  interface WindowWithAuth extends Window {
    testAuth: typeof testAuthentication;
  }
  (window as unknown as WindowWithAuth).testAuth = testAuthentication;
}